import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';

const ZohoCallbackPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // After auth, Zoho redirects here. We get the return URL from session storage.
        const returnUrl = sessionStorage.getItem('zoho_auth_return_url') || '/app/tickets';
        
        // After a brief delay, send the user back to where they were.
        const timer = setTimeout(() => {
            navigate(returnUrl, { replace: true });
        }, 2500); // 2.5-second delay

        return () => clearTimeout(timer); // Cleanup timer
    }, [navigate]);

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-neo-page text-white">
            <Icon icon="line-md:confirm-circle" className="text-6xl text-green-500 mb-4" />
            <h1 className="text-2xl font-semibold mb-2">Authentication Successful!</h1>
            <p className="text-gray-400">Your account has been connected to Zoho Desk.</p>
            <p className="text-gray-400 mt-1">Redirecting you back to the application...</p>
        </div>
    );
};

export default ZohoCallbackPage;